import styled, { css } from 'styled-components'

export const SwitchButton = styled.div`
    display: flex;
    margin-bottom: 4px;
    margin-top: 4px;
`

export const CheckBoxWrapper = styled.div`
    position: relative;
    margin-right: 32px;
`

export const CheckBoxLabel = styled.label`
    position: absolute;
    top: 0;
    left: 0;
    width: 32px;
    height: 16px;
    border-radius: 16px;
    background: var(--gray-300);
    cursor: pointer;

    &::after {
        content: '';
        display: block;
        border-radius: 50%;
        width: 10px;
        height: 10px;
        margin: 3px;
        background: #ffffff;
        box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
        transition: 0.2s;
    }
`

const whenCheckboxIsChecked = css`
    & + ${CheckBoxLabel} {
        background: var(--blue-500);

        &::after {
            content: '';
            display: block;
            border-radius: 50%;
            width: 10px;
            height: 10px;
            margin-left: 19px;
            transition: 0.2s;
        }
    }
`

export const CheckBox = styled.input<{ checked: boolean }>`
    opacity: 0;
    z-index: 1;
    border-radius: 16px;
    width: 32px;
    height: 16px;
    visibility: hidden;

    ${({ checked }) => checked && whenCheckboxIsChecked}

    &:disabled + ${CheckBoxLabel} {
        cursor: not-allowed;
        opacity: 0.4;
    }
`

export const SwitchLabel = styled.label`
    font-weight: normal;
    font-size: 13px;
    line-height: 16px;
`
